<template>
  <div
    :style="{
      backgroundColor: config.appBackgroundColor,
      backgroundImage: config.appBackgroundImage
        ? startsWith(config.appBackgroundImage, 'url')
          ? config.appBackgroundImage
          : `url('${
              startsWith(config.appBackgroundImage, 'http')
                ? ''
                : config.publicPath
            }${config.appBackgroundImage}')`
        : null,
      backgroundPosition: config.appBackgroundPosition,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }"
    class="topics-page-main-container"
  >
    <div class="topics-page-top-container">
      <Header class="app-header">
        <template v-slot:center>
          <h2>{{ $t("topics.headerTitle") }}</h2>
        </template></Header
      >
      <div class="topics-page-content-container">
        <div
          v-if="startsWith(config.appLogo, '<svg ')"
          v-html="config.appLogo"
          :class="
            ['mdr-app-logo-container'].concat(
              isKioskType &&
                keys(pick(config.topicsPageLogoPosition, ['right', 'left']))
                  .length
                ? []
                : ['centered-x'],
              isKioskType &&
                keys(pick(config.topicsPageLogoPosition, ['top', 'bottom']))
                  .length
                ? []
                : ['centered-y']
            )
          "
        />
        <div
          v-else-if="config.appLogo"
          :class="
            ['mdr-app-logo-container'].concat(
              isKioskType &&
                keys(pick(config.topicsPageLogoPosition, ['right', 'left']))
                  .length
                ? []
                : ['centered-x'],
              isKioskType &&
                keys(pick(config.topicsPageLogoPosition, ['top', 'bottom']))
                  .length
                ? []
                : ['centered-y']
            )
          "
        >
          <img
            :src="
              `${startsWith(config.appLogo, 'http') ? '' : config.publicPath}${
                config.appLogo
              }`
            "
          />
        </div>

        <div class="ellastic">
          <template v-if="isServiceAvailable === true">
            <Spinner v-if="!topics" class="mt-3 mb-3" />
            <template v-else-if="values(topics).length">
              <h2
                v-if="
                  config.topicsPageTitleEnabled !== false &&
                    config.topicsPageTitleText?.[locale]
                "
                :style="{
                  color: config.appTextColor,
                  textAlign: config.topicsPageTitleTextAlign
                }"
                :class="
                  ['topics-page-title'].concat(
                    isKioskType &&
                      keys(
                        pick(config?.topicsPageTitlePosition, ['top', 'bottom'])
                      ).length === 1
                      ? ['centered']
                      : [],
                    isKioskType &&
                      keys(
                        pick(config.topicsPageTitlePosition, ['top', 'bottom'])
                      ).length
                      ? []
                      : ['centered-y'],
                    isKioskType &&
                      keys(
                        pick(config.topicsPageTitlePosition, ['left', 'right'])
                      ).length
                      ? []
                      : ['centered-x']
                  )
                "
              >
                {{ decodeURI(config.topicsPageTitleText?.[locale]) }}
              </h2>
              <div
                v-if="values(topics).length > 10"
                class="topics-page-search-container"
              >
                <label v-show="false" for="search" />
                <input
                  v-model="searchString"
                  :class="{ 'topics-page-search-input--rtl': isRtl }"
                  class="topics-page-search-input"
                  id="search"
                  :placeholder="$t('topics.search')"
                />
                <svg
                  :class="{ 'topics-page-search-icon--rtl': isRtl }"
                  class="topics-page-search-icon"
                  fill="none"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="6.22222"
                    cy="6.22222"
                    r="5.22222"
                    stroke="#646C80"
                    stroke-width="2"
                  ></circle>
                  <path
                    d="M10.2222 10.2222L14.2222 14.2222"
                    stroke="#646C80"
                    stroke-linecap="round"
                    stroke-width="2"
                  ></path>
                </svg>
              </div>
              <div
                :class="
                  ['topics-container'].concat(
                    config.topicButtonAppearance
                      ? [
                          config.topicButtonAppearance.match(/type-\d/g)[0]
                        ].concat(
                          config.topicButtonAppearance.split(/type-\d-/)
                            .length === 2
                            ? [
                                lowerCase(
                                  config.topicButtonAppearance.split(
                                    /type-\d-/
                                  )[1]
                                )
                              ]
                            : []
                        )
                      : [
                          isKioskType
                            ? ''
                            : `type-${
                                values(topics).length === 1
                                  ? '1'
                                  : values(topics).length > 5
                                  ? '3'
                                  : '2'
                              }`
                        ],
                    isRtl ? ['topics-container--rtl'] : [],
                    config.appSchedulePermanentVisible ? ['tail-schedule'] : [],
                    isKioskType && keys(config.topicMenuPosition).length < 2
                      ? ['centered']
                      : [],
                    isKioskType &&
                      keys(pick(config.topicMenuPosition, ['top', 'bottom']))
                        .length
                      ? []
                      : ['centered-y'],
                    isKioskType &&
                      keys(pick(config.topicMenuPosition, ['left', 'right']))
                        .length
                      ? []
                      : ['centered-x'],
                    isKioskType && config.topicMenuDirection
                      ? [`direction_${config.topicMenuDirection}`]
                      : []
                  )
                "
              >
                <template v-for="(topic, i) in topics" :key="i">
                  <button
                    v-show="
                      searchString
                        ? getTopicTitle(topic, locale)
                            .toLowerCase()
                            .includes(searchString.toLowerCase())
                        : true
                    "
                    @click="
                      () =>
                        config.customerInfoFormEnabled
                          ? (targetTopic = i)
                          : handleTopicChosen(i)
                    "
                    :class="[
                      'topic-item',
                      isRtl ? 'topic-item--rtl' : '',
                      isKioskType && config?.topicButtonShadowEnabled
                        ? 'shadow'
                        : ''
                    ]"
                    :disabled="!topic.experts?.length"
                  >
                    <span
                      v-if="
                        find(config.topicsImages, v => v.topic === i)?.image
                      "
                      class="topic-image-container"
                    >
                      <span class="topic-image-inner-container">
                        <img
                          :src="
                            `${config.publicPath}${
                              find(config.topicsImages, v => v.topic === i)
                                ?.image
                            }`
                          "
                          class="topic-image"
                        />
                      </span>
                    </span>
                    <svg
                      v-else
                      class="topic-image-camera"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="fill"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13 12C10.7909 12 9 13.7909 9 16V24C9 26.2091 10.7909 28 13 28H22C24.2091 28 26 26.2091 26 24V23.5L29.6 26.2C30.5889 26.9416 32 26.2361 32 25V15C32 13.7639 30.5889 13.0584 29.6 13.8L26 16.5V16C26 13.7909 24.2091 12 22 12H13ZM26 19V21L30 24V16L26 19ZM24 18V16C24 14.8954 23.1046 14 22 14H13C11.8954 14 11 14.8954 11 16V24C11 25.1046 11.8954 26 13 26H22C23.1046 26 24 25.1046 24 24V22V21.5V18.5V18Z"
                      />
                    </svg>
                    <span class="topic-title">{{
                      getTopicTitle(topic, locale)
                    }}</span>
                    <svg
                      :class="[
                        'topic-image-ico',
                        find(config.topicsImages, v => v.topic === i)?.image
                          ? ''
                          : 'hidden'
                      ]"
                      width="44"
                      height="44"
                      viewBox="0 0 44 44"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="fill"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.5 18.8C4.5 15.7197 4.5 14.1796 5.07222 13.0031C5.57555 11.9682 6.3787 11.1268 7.36655 10.5995C8.48959 10 9.95972 10 12.9 10H25.1C28.0403 10 29.5104 10 30.6334 10.5995C31.6213 11.1268 32.4244 11.9682 32.9278 13.0031C33.4616 14.1006 33.4974 15.5146 33.4998 18.2001L40.063 12.9496C41.0451 12.1639 42.5 12.8632 42.5 14.1209V29.879C42.5 31.1368 41.0451 31.8361 40.063 31.0503L33.4998 25.7998C33.4974 28.4854 33.4616 29.8994 32.9278 30.9969C32.4244 32.0318 31.6213 32.8732 30.6334 33.4005C29.5104 34 28.0403 34 25.1 34H12.9C9.95972 34 8.48959 34 7.36655 33.4005C6.3787 32.8732 5.57555 32.0318 5.07222 30.9969C4.5 29.8204 4.5 28.2803 4.5 25.2V18.8Z"
                      />
                    </svg>
                  </button>
                </template>
              </div>
            </template>
            <div
              v-if="
                (topics && !values(topics).length) ||
                  (searchString &&
                    !find(topics, t =>
                      (getTopicTitle(t, locale) ?? '')
                        .toLowerCase()
                        .includes(searchString.toLowerCase())
                    ))
              "
              class="topics-not-found"
            >
              <img
                :src="require('@/assets/img/notFound.svg')"
                alt="Not Found"
                class="topics-not-found-icon"
                role="presentation"
              />
              <h2 class="topics-not-found-title">
                {{ $t(searchString ? "topics.notFound" : "topics.noTopics") }}
              </h2>
            </div>
          </template>
          <div v-if="isScheduleVisible" class="mdr-schedule-container">
            <h6
              v-if="config.appScheduleTitleText?.[locale]"
              :style="{ color: config.appTextColor }"
              class="text-center mt-5 mb-3"
            >
              {{ decodeURI(config.appScheduleTitleText?.[locale]) }}
            </h6>
            <div
              :style="{
                backgroundColor: !isKioskType
                  ? config.appAltBackgroundColor || 'rgba(0, 0, 0, 0.25)'
                  : 'transparent'
              }"
              class="mdr-schedule"
            >
              <div class="col-12 mx-auto">
                <ul v-if="scheduleData">
                  <li
                    v-for="(data, i) of scheduleData"
                    :key="i"
                    :style="{ color: config.appScheduleTextColor }"
                  >
                    {{ data.day }}:
                    <em :style="{ color: config.appScheduleTextColor }">{{
                      data.times ?? $t("topics.schedule.closed")
                    }}</em>
                  </li>
                </ul>
              </div>
            </div>
            <div
              v-if="config.appScheduleNote?.[locale]"
              :style="{
                color: config.appTextColor,
                textAlign: config.appScheduleNoteAlign
              }"
              class="note"
            >
              {{ decodeURI(config.appScheduleNote?.[locale]) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="config.copyrightText?.[locale]"
      class="topics-page-bottom-container"
    >
      <Copyright />
    </div>

    <PoweredBy v-else class="bottom center dark" />
  </div>

  <transition name="fade">
    <Modal
      v-if="targetTopic"
      @close="targetTopic = null"
      :position="ModalPosition.center"
      :size="ModalSize.lg"
      :close-button-visible="false"
    >
      <template v-slot:body>
        <Form
          v-slot="{ meta, errors }"
          @submit="handleCustomerInfoSubmit"
          :initial-values="customerInfo"
          class="mdr-contacts-form"
        >
          <h4 class="text-center">{{ $t("topics.customerInfoForm.title") }}</h4>

          <template
            v-for="(val, field) in config.customerInfoFormFields"
            :key="field"
          >
            <div v-if="val?.enabled" class="mb-3">
              <label :for="field" class="form-label">
                {{ val?.label?.[locale] }}
                <template v-if="!val?.required"
                  >({{ $t("topics.customerInfoForm.optional") }})</template
                >
              </label>
              <PhoneInput
                v-if="field === 'phone'"
                name="phone"
                as="select"
                :rules="{
                  required: !!config.customerInfoFormFields?.phone?.required
                }"
                :label="val?.label?.[locale]?.toLowerCase() ?? ''"
              />
              <template v-else>
                <Field
                  :class="
                    ['form-control'].concat(errors[field] ? ['is-invalid'] : [])
                  "
                  :label="val?.label?.[locale]?.toLowerCase()"
                  :name="field"
                  :rules="{
                    required: !!config.customerInfoFormFields?.[field]
                      ?.required,
                    email: field === 'email'
                  }"
                  :id="field"
                  autocomplete="off"
                />
                <ErrorMessage :name="field" class="invalid-feedback" />
              </template>
            </div>
          </template>

          <div class="mdr-contacts-modal-footer flex-column">
            <button
              :disabled="!meta.valid"
              type="submit"
              class="btn btn-success mdr-call-button"
            >
              <svg
                width="28"
                height="24"
                viewBox="0 0 28 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="1"
                  y="3.99512"
                  width="18"
                  height="16"
                  rx="2"
                  class="str"
                  stroke-width="2"
                ></rect>
                <path
                  d="M19 9.99512L24.4657 5.22344C24.6344 5.07623 24.8506 4.99512 25.0744 4.99512V4.99512C25.5856 4.99512 26 5.4095 26 5.92067V18.0696C26 18.5807 25.5856 18.9951 25.0744 18.9951V18.9951C24.8506 18.9951 24.6344 18.914 24.4657 18.7668L19 13.9951"
                  class="str"
                  stroke-width="2"
                ></path>
              </svg>
              {{ $t("topics.customerInfoForm.buttons.submit") }}
            </button>
            <button
              @click="targetTopic = null"
              type="button"
              class="btn btn-secondary mdr-cancel-call"
            >
              {{ $t("topics.customerInfoForm.buttons.cancel") }}
            </button>
          </div>
        </Form>
      </template>
    </Modal>
  </transition>
</template>

<script lang="ts">
import { useStore } from "vuex";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import Spinner from "@/components/Spinner.vue";
import {
  TopicDTO,
  EndpointStatus
} from "@moderrotech/servers-communication-library/src/types";
import Header from "@/components/Header.vue";
import Copyright from "@/components/Copyright.vue";
import PoweredBy from "@/components/PoweredBy.vue";
import _ from "lodash";
import { isLangRtl } from "@moderrotech/servers-communication-library/src/helpers/lang";
import moment from "moment-timezone";
import Modal, { ModalSize, ModalPosition } from "@/components/Modal.vue";
import { Form, Field, ErrorMessage, FormActions } from "vee-validate";
import { useRoute, useRouter } from "vue-router";
import { legacyTimezones } from "@/helpers/time";
import { useTimestamp, useIdle, useSessionStorage } from "@vueuse/core";
import PhoneInput from "@/components/inputs/PhoneInput.vue";
import { customerInfoStorageKey } from "@/store";

export default {
  components: {
    PhoneInput,
    Copyright,
    Header,
    Spinner,
    Modal,
    Form,
    Field,
    ErrorMessage,
    PoweredBy
  },
  emits: ["idle"],
  setup(props: {}, context: { emit: Function }) {
    const targetTopic = ref<string | null>();

    const store = useStore();
    const searchString = ref(null);

    const config = computed(() => store.state.config.config),
      locale = computed((): string => config.value?.appLocale);

    const schedulePeriods = computed(
        () => store.state.auth.profile?.app?.schedule?.periods
      ),
      scheduleTimezone = computed(() => {
        const tz = store.state.auth.profile?.app?.schedule?.timezone;

        return _.includes(moment.tz.names(), tz)
          ? tz
          : _.findKey(legacyTimezones, z => z === tz);
      });

    const { timestamp } = useTimestamp({ controls: true, interval: 500 });

    const isServiceAvailable = computed(() => {
      if (store.getters.isQueueSuspended) {
        return false;
      }
      if (!scheduleTimezone.value) {
        return false;
      }

      const now = moment(timestamp.value).tz(scheduleTimezone.value),
        day = now
          .day(now.day())
          .locale("en")
          .format("dd"),
        hours = now.hours(),
        minutes = now.minutes();

      return (schedulePeriods.value?.[day]?.from?.hours ?? null) === null ||
        (schedulePeriods.value?.[day]?.from?.minutes ?? null) === null ||
        (schedulePeriods.value?.[day]?.to?.hours ?? null) === null ||
        (schedulePeriods.value?.[day]?.to?.minutes ?? null) === null
        ? false
        : schedulePeriods.value?.[day]?.from?.hours <= hours &&
            (schedulePeriods.value?.[day]?.from?.hours === hours
              ? schedulePeriods.value?.[day]?.from?.minutes <= minutes
              : true) &&
            schedulePeriods.value?.[day]?.to?.hours >= hours &&
            (schedulePeriods.value?.[day]?.to?.hours === hours
              ? schedulePeriods.value?.[day]?.to?.minutes > minutes
              : true);
    });

    let scheduleTimer: number | null = null;

    onMounted(() => {
      scheduleTimer = window.setInterval(
        () => isServiceAvailable.effect.raw(),
        5000
      );
    });
    onUnmounted(() => window.clearInterval(scheduleTimer ?? undefined));

    const isScheduleVisible = computed(
      () =>
        !isServiceAvailable.value || config.value.appSchedulePermanentVisible
    );

    const parseSchedulePeriod = (
      day: string
    ): Record<
      "openHours" | "openMinutes" | "closeHours" | "closeMinutes",
      number
    > | null => {
      if (
        (schedulePeriods.value?.[day]?.from?.hours ?? null) === null ||
        (schedulePeriods.value?.[day]?.from?.minutes ?? null) === null ||
        (schedulePeriods.value?.[day]?.to?.hours ?? null) === null ||
        (schedulePeriods.value?.[day]?.to?.minutes ?? null) === null
      ) {
        return null;
      }

      return {
        openHours: +schedulePeriods.value?.[day].from.hours,
        openMinutes: +schedulePeriods.value?.[day].from.minutes,
        closeHours: +schedulePeriods.value?.[day].to.hours,
        closeMinutes: +schedulePeriods.value?.[day].to.minutes
      };
    };

    const scheduleData = computed(() => {
      if (!scheduleTimezone.value) {
        return null;
      }

      const now = moment().tz(scheduleTimezone.value);

      const firstWeekDay = moment.localeData().firstDayOfWeek();

      let data = _.map(
        _.concat(
          _.filter(_.range(0, 7), d => d >= firstWeekDay),
          _.filter(_.range(0, 7), d => d < firstWeekDay)
        ),
        i => {
          const dayAbbreviation = moment()
            .day(i)
            .locale("en")
            .format("dd");

          const times = parseSchedulePeriod(dayAbbreviation);

          const defaultTimeFormat = "h:mm a";

          const convertTimeFormat = (format: string) => {
            const pythonToJsFormats = {
              "%-I:%M %p": defaultTimeFormat, // 12h
              "%-H:%M": "H:mm" // 24h
            };
            return _.get(pythonToJsFormats, format);
          };

          const timeFormat = config.value.timeFormat
            ? convertTimeFormat(config.value.timeFormat as string)
            : defaultTimeFormat;

          // for japanese should be used AM/PM instead of hieroglyphs
          const isJapanese = locale.value === "ja";

          return _.assign(
            {
              day: _.startCase(
                moment()
                  .day(i)
                  .format("dddd")
              )
            },
            times &&
              !(
                times.openHours === times.closeHours &&
                times.openMinutes === times.closeMinutes
              )
              ? {
                  times: `${moment(
                    `${times.openHours}:${times.openMinutes}`,
                    "H:m"
                  )
                    .locale(isJapanese ? "en" : locale.value)
                    .format(timeFormat)} -
            ${
              timeFormat === "H:mm" && +times.closeHours! === 24
                ? "24:00"
                : moment(`${times.closeHours}:${times.closeMinutes}`, "H:m")
                    .locale(isJapanese ? "en" : locale.value)
                    .format(timeFormat)
            }${
                    (config.value.appScheduleDisplayTimezone ?? true) &&
                    moment.tz.zone(scheduleTimezone.value)?.abbr(+now)
                      ? ` (${moment.tz
                          .zone(scheduleTimezone.value)
                          ?.abbr(+now)})`
                      : ""
                  }`
                }
              : {}
          );
        }
      );

      if (!config.value.minimizeSchedule) {
        return data;
      }

      data = _.filter(data, d => !!d.times); // filter not working days

      const minimizedData = [];

      let i = 0;
      while (i < data.length) {
        const equalRows = [data[i]];
        i++;

        for (let j = i; j < data.length; j++) {
          if (data[j].times === equalRows[0].times) {
            equalRows.push(data[j]);
            i++;
          } else {
            break;
          }
        }

        if (equalRows.length === 1) {
          minimizedData.push(equalRows[0]);
        } else if (equalRows.length === 2) {
          minimizedData.push({
            day: `${equalRows[0].day}, ${equalRows[1].day}`,
            times: equalRows[0].times
          });
        } else {
          minimizedData.push({
            day: `${equalRows[0].day} - ${_.last(equalRows)!.day}`,
            times: equalRows[0].times
          });
        }
      }

      return minimizedData;
    });

    const kioskId = store.state.auth.kioskId;

    kioskId
      ? store.commit("metadata/UNSET_CUSTOMER_INFO")
      : store.commit(
          "metadata/SET_CUSTOMER_INFO",
          useSessionStorage(customerInfoStorageKey, {})
        );

    const customerInfo = computed(() => store.state.metadata.customerInfo);

    const router = useRouter(),
      route = useRoute();

    const handleTopicChosen = async (id: string) =>
      await router.replace({
        name: "app",
        params: route.params,
        query: _.assign({ topic: id }, route.query)
      });

    const endpointStatusCode = computed(() => store.getters.endpointStatusCode);

    const handleCustomerInfoSubmit = (
      values: { [k: string]: string },
      actions: FormActions<any>
    ) => {
      actions.resetForm();
      store.commit("metadata/SET_CUSTOMER_INFO", values);

      handleTopicChosen(targetTopic.value!);
    };

    const { idle } = useIdle(2 * 60 * 1000); // 2 min

    watch(
      () => idle.value,
      v => {
        if (v) {
          context.emit("idle");
        }
      },
      { immediate: true }
    );

    const getTopicTitle = (topic: Pick<TopicDTO, "title">, lang?: string) =>
      store.getters["topics/getTitle"]?.(topic, lang);

    return {
      searchString,
      // do not show topics without assigned experts or without title translation
      topics: computed((): Record<string, TopicDTO> | null =>
        store.state.topics.list
          ? _.fromPairs(
              _.map(
                _.sortBy(
                  _.map(
                    _.omitBy(
                      store.state.topics.list,
                      t =>
                        getTopicTitle(t, locale.value) === null ||
                        !_.find(
                          t?.kiosks ?? [],
                          id =>
                            _.trimEnd(_.trimStart(id, "{"), "}") ===
                            store.getters["auth/clientId"]
                        )
                    ),
                    (t, id) =>
                      _.assign(
                        { id },
                        t,
                        _.omitBy(
                          {
                            order: store.getters["auth/property"]?.(
                              "topics.order"
                            )?.[id]
                          },
                          _.isNil
                        )
                      )
                  ),
                  "order"
                ),
                t => [t.id, _.omit(t, "id")]
              )
            )
          : null
      ),
      config: computed(() => store.state.config.config),
      isRtl: computed(() => isLangRtl(locale.value)),
      isServiceAvailable,
      scheduleData,
      isScheduleVisible,
      getTopicTitle,
      handleTopicChosen,
      endpointStatusCode,
      EndpointStatus,
      targetTopic,
      ModalPosition,
      ModalSize,
      handleCustomerInfoSubmit,
      customerInfo,
      locale,
      isKioskType: computed(() => store.getters["auth/isKioskType"]),
      clientId: computed(() => store.getters["auth/clientId"]),
      ..._.pick(_, [
        "values",
        "assign",
        "pick",
        "startsWith",
        "find",
        "lowerCase",
        "keys",
        "includes"
      ])
    };
  }
};
</script>

<style lang="scss">
@import "../assets/styles/bootstrap.css";
@import "../assets/styles/breakpoints.module";
@import "../assets/styles/topics-page.scss";
</style>
